<template>
  <div id="bottomRightBtm">
    <div class="bg-color-black">
      <myTitle :icon="'chart-line'">任务完成排行榜</myTitle>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
import myTitle from '@/components/common/title'
export default {
  data() {
    return {
      config: {
        header: ['组件', '分支', '覆盖率'],
        data: [
          ['制冷系统', 'dev-1', "<span  class='colorGrass'>↑75%</span>"],
          ['供热系统', 'dev-2', "<span  class='colorRed'>↓33%</span>"],
          ['照明系统', 'dev-3', "<span  class='colorGrass'>↑100%</span>"],
          ['配电系统', 'rea-1', "<span  class='colorGrass'>↑94%</span>"],
          ['电梯系统', 'rea-2', "<span  class='colorGrass'>↑95%</span>"],
          ['空调系统', 'fix-2', "<span  class='colorGrass'>↑63%</span>"],
          ['末端系统', 'fix-4', "<span  class='colorGrass'>↑84%</span>"],
          ['其他系统', 'fix-7', "<span  class='colorRed'>↓46%</span>"]
        ],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [100],
        align: ['center']
      }
    }
  },
  components: {
    myTitle
  },
}
</script>

<style lang="scss" scoped>
$box-height: 640px;
$box-width: 100%;

#bottomRightBtm {
  padding: 16px;
  padding-top: 20px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .body-box {
    border-radius: 10px;
    overflow: hidden;

    .dv-scr-board {
      width: 100%;
      height: 510px;
    }
  }
}
</style>
